// Keep in sync with Addresses::Validations::PostalCode::COUNTRY_CODES_WITHOUT_POSTAL_CODE.
const COUNTRIES_WITHOUT_POSTAL_CODE = [
  'AO', 'AG', 'AW', 'AC', 'BH', 'BS', 'BZ', 'BJ', 'BW', 'BO', 'BQ', 'BF',
  'BI', 'CM', 'CF', 'KM', 'CG', 'CD', 'CK', 'CI', 'CW', 'DJ', 'DM', 'TL',
  'GQ', 'ER', 'FJ', 'TF', 'GM', 'GA', 'GH', 'GD', 'GY', 'HM', 'HK', 'KI',
  'LY', 'MO', 'MW', 'ML', 'MR', 'NR', 'AN', 'NU', 'KP', 'PA', 'QA', 'RW',
  'KN', 'ST', 'SC', 'SL', 'SB', 'SR', 'SY', 'TG', 'TK', 'TO', 'TV', 'UG',
  'AE', 'VU', 'YE', 'ZW'
]

export const countryCodeFromAddressComponents = (addressComponents) => {
  const country = addressComponents.find((component) => {
    return component.types?.includes('country')
  })

  return country?.short_name
}

export const missingAddressComponents = (place) => {
  if (!place) return ['place']

  const addressComponents = place.address_components || []
  const hasType = (type) => addressComponents.some((component) => {
    return component.types?.includes(type)
  })
  const countryCode = countryCodeFromAddressComponents(addressComponents)
  const missing = []

  if (!hasType('country')) missing.push('country')
  if (!hasType('locality') && !hasType('postal_town')) missing.push('city')
  if (!hasType('postal_code') &&
      !COUNTRIES_WITHOUT_POSTAL_CODE.includes(countryCode)) {
    missing.push('postal_code')
  }

  return missing
}
